/* eslint-disable import/max-dependencies */
/* Auto-generated by scripts/build-expertise-city-locale-overlays.mjs — do not edit. */

import fr_core_arbeitsrecht_kaiserslautern from "./expertiseCity/core/arbeitsrecht/kaiserslautern.json";
import fr_judgements_arbeitsrecht_kaiserslautern from "./expertiseCity/judgements/arbeitsrecht/kaiserslautern.json";
import fr_core_arbeitsrecht_koblenz from "./expertiseCity/core/arbeitsrecht/koblenz.json";
import fr_judgements_arbeitsrecht_koblenz from "./expertiseCity/judgements/arbeitsrecht/koblenz.json";
import fr_core_arbeitsrecht_landau_pfalz from "./expertiseCity/core/arbeitsrecht/landau-pfalz.json";
import fr_judgements_arbeitsrecht_landau_pfalz from "./expertiseCity/judgements/arbeitsrecht/landau-pfalz.json";
import fr_core_arbeitsrecht_muenchen from "./expertiseCity/core/arbeitsrecht/muenchen.json";
import fr_judgements_arbeitsrecht_muenchen from "./expertiseCity/judgements/arbeitsrecht/muenchen.json";
import fr_core_arbeitsrecht_pirmasens from "./expertiseCity/core/arbeitsrecht/pirmasens.json";
import fr_judgements_arbeitsrecht_pirmasens from "./expertiseCity/judgements/arbeitsrecht/pirmasens.json";
import fr_core_arbeitsrecht_stuttgart from "./expertiseCity/core/arbeitsrecht/stuttgart.json";
import fr_judgements_arbeitsrecht_stuttgart from "./expertiseCity/judgements/arbeitsrecht/stuttgart.json";
import fr_core_erbrecht_kaiserslautern from "./expertiseCity/core/erbrecht/kaiserslautern.json";
import fr_judgements_erbrecht_kaiserslautern from "./expertiseCity/judgements/erbrecht/kaiserslautern.json";
import fr_core_erbrecht_koblenz from "./expertiseCity/core/erbrecht/koblenz.json";
import fr_judgements_erbrecht_koblenz from "./expertiseCity/judgements/erbrecht/koblenz.json";
import fr_core_erbrecht_landau_pfalz from "./expertiseCity/core/erbrecht/landau-pfalz.json";
import fr_judgements_erbrecht_landau_pfalz from "./expertiseCity/judgements/erbrecht/landau-pfalz.json";
import fr_core_erbrecht_muenchen from "./expertiseCity/core/erbrecht/muenchen.json";
import fr_judgements_erbrecht_muenchen from "./expertiseCity/judgements/erbrecht/muenchen.json";
import fr_core_erbrecht_pirmasens from "./expertiseCity/core/erbrecht/pirmasens.json";
import fr_judgements_erbrecht_pirmasens from "./expertiseCity/judgements/erbrecht/pirmasens.json";
import fr_core_erbrecht_stuttgart from "./expertiseCity/core/erbrecht/stuttgart.json";
import fr_judgements_erbrecht_stuttgart from "./expertiseCity/judgements/erbrecht/stuttgart.json";
import fr_core_gesellschaftsrecht_heilbronn from "./expertiseCity/core/gesellschaftsrecht/heilbronn.json";
import fr_judgements_gesellschaftsrecht_heilbronn from "./expertiseCity/judgements/gesellschaftsrecht/heilbronn.json";
import fr_core_gesellschaftsrecht_kaiserslautern from "./expertiseCity/core/gesellschaftsrecht/kaiserslautern.json";
import fr_judgements_gesellschaftsrecht_kaiserslautern from "./expertiseCity/judgements/gesellschaftsrecht/kaiserslautern.json";
import fr_core_gesellschaftsrecht_koblenz from "./expertiseCity/core/gesellschaftsrecht/koblenz.json";
import fr_judgements_gesellschaftsrecht_koblenz from "./expertiseCity/judgements/gesellschaftsrecht/koblenz.json";
import fr_core_gesellschaftsrecht_koeln from "./expertiseCity/core/gesellschaftsrecht/koeln.json";
import fr_judgements_gesellschaftsrecht_koeln from "./expertiseCity/judgements/gesellschaftsrecht/koeln.json";
import fr_core_gesellschaftsrecht_landau_pfalz from "./expertiseCity/core/gesellschaftsrecht/landau-pfalz.json";
import fr_judgements_gesellschaftsrecht_landau_pfalz from "./expertiseCity/judgements/gesellschaftsrecht/landau-pfalz.json";
import fr_core_gesellschaftsrecht_muenchen from "./expertiseCity/core/gesellschaftsrecht/muenchen.json";
import fr_judgements_gesellschaftsrecht_muenchen from "./expertiseCity/judgements/gesellschaftsrecht/muenchen.json";
import fr_core_gesellschaftsrecht_pirmasens from "./expertiseCity/core/gesellschaftsrecht/pirmasens.json";
import fr_judgements_gesellschaftsrecht_pirmasens from "./expertiseCity/judgements/gesellschaftsrecht/pirmasens.json";
import fr_core_gesellschaftsrecht_stuttgart from "./expertiseCity/core/gesellschaftsrecht/stuttgart.json";
import fr_judgements_gesellschaftsrecht_stuttgart from "./expertiseCity/judgements/gesellschaftsrecht/stuttgart.json";
import fr_core_insolvenzrecht_koblenz from "./expertiseCity/core/insolvenzrecht/koblenz.json";
import fr_judgements_insolvenzrecht_koblenz from "./expertiseCity/judgements/insolvenzrecht/koblenz.json";
import fr_core_insolvenzrecht_koeln from "./expertiseCity/core/insolvenzrecht/koeln.json";
import fr_judgements_insolvenzrecht_koeln from "./expertiseCity/judgements/insolvenzrecht/koeln.json";
import fr_core_insolvenzrecht_landau_pfalz from "./expertiseCity/core/insolvenzrecht/landau-pfalz.json";
import fr_judgements_insolvenzrecht_landau_pfalz from "./expertiseCity/judgements/insolvenzrecht/landau-pfalz.json";
import fr_core_internetmedienrecht_kaiserslautern from "./expertiseCity/core/internetmedienrecht/kaiserslautern.json";
import fr_judgements_internetmedienrecht_kaiserslautern from "./expertiseCity/judgements/internetmedienrecht/kaiserslautern.json";
import fr_core_internetmedienrecht_koblenz from "./expertiseCity/core/internetmedienrecht/koblenz.json";
import fr_judgements_internetmedienrecht_koblenz from "./expertiseCity/judgements/internetmedienrecht/koblenz.json";
import fr_core_internetmedienrecht_landau_pfalz from "./expertiseCity/core/internetmedienrecht/landau-pfalz.json";
import fr_judgements_internetmedienrecht_landau_pfalz from "./expertiseCity/judgements/internetmedienrecht/landau-pfalz.json";
import fr_core_internetmedienrecht_muenchen from "./expertiseCity/core/internetmedienrecht/muenchen.json";
import fr_judgements_internetmedienrecht_muenchen from "./expertiseCity/judgements/internetmedienrecht/muenchen.json";
import fr_core_internetmedienrecht_stuttgart from "./expertiseCity/core/internetmedienrecht/stuttgart.json";
import fr_judgements_internetmedienrecht_stuttgart from "./expertiseCity/judgements/internetmedienrecht/stuttgart.json";
import fr_core_prozessfuehrung_kaiserslautern from "./expertiseCity/core/prozessfuehrung/kaiserslautern.json";
import fr_judgements_prozessfuehrung_kaiserslautern from "./expertiseCity/judgements/prozessfuehrung/kaiserslautern.json";
import fr_core_prozessfuehrung_koblenz from "./expertiseCity/core/prozessfuehrung/koblenz.json";
import fr_judgements_prozessfuehrung_koblenz from "./expertiseCity/judgements/prozessfuehrung/koblenz.json";
import fr_core_prozessfuehrung_landau_pfalz from "./expertiseCity/core/prozessfuehrung/landau-pfalz.json";
import fr_judgements_prozessfuehrung_landau_pfalz from "./expertiseCity/judgements/prozessfuehrung/landau-pfalz.json";
import fr_core_prozessfuehrung_muenchen from "./expertiseCity/core/prozessfuehrung/muenchen.json";
import fr_judgements_prozessfuehrung_muenchen from "./expertiseCity/judgements/prozessfuehrung/muenchen.json";
import fr_core_prozessfuehrung_stuttgart from "./expertiseCity/core/prozessfuehrung/stuttgart.json";
import fr_judgements_prozessfuehrung_stuttgart from "./expertiseCity/judgements/prozessfuehrung/stuttgart.json";
import fr_core_startuprecht_kaiserslautern from "./expertiseCity/core/startuprecht/kaiserslautern.json";
import fr_judgements_startuprecht_kaiserslautern from "./expertiseCity/judgements/startuprecht/kaiserslautern.json";
import fr_core_startuprecht_koblenz from "./expertiseCity/core/startuprecht/koblenz.json";
import fr_judgements_startuprecht_koblenz from "./expertiseCity/judgements/startuprecht/koblenz.json";
import fr_core_startuprecht_landau_pfalz from "./expertiseCity/core/startuprecht/landau-pfalz.json";
import fr_judgements_startuprecht_landau_pfalz from "./expertiseCity/judgements/startuprecht/landau-pfalz.json";
import fr_core_startuprecht_muenchen from "./expertiseCity/core/startuprecht/muenchen.json";
import fr_judgements_startuprecht_muenchen from "./expertiseCity/judgements/startuprecht/muenchen.json";
import fr_core_startuprecht_stuttgart from "./expertiseCity/core/startuprecht/stuttgart.json";
import fr_judgements_startuprecht_stuttgart from "./expertiseCity/judgements/startuprecht/stuttgart.json";
import fr_core_steuerrecht_kaiserslautern from "./expertiseCity/core/steuerrecht/kaiserslautern.json";
import fr_judgements_steuerrecht_kaiserslautern from "./expertiseCity/judgements/steuerrecht/kaiserslautern.json";
import fr_core_steuerrecht_koblenz from "./expertiseCity/core/steuerrecht/koblenz.json";
import fr_judgements_steuerrecht_koblenz from "./expertiseCity/judgements/steuerrecht/koblenz.json";
import fr_core_steuerrecht_landau_pfalz from "./expertiseCity/core/steuerrecht/landau-pfalz.json";
import fr_judgements_steuerrecht_landau_pfalz from "./expertiseCity/judgements/steuerrecht/landau-pfalz.json";
import fr_core_steuerrecht_muenchen from "./expertiseCity/core/steuerrecht/muenchen.json";
import fr_judgements_steuerrecht_muenchen from "./expertiseCity/judgements/steuerrecht/muenchen.json";
import fr_core_steuerrecht_stuttgart from "./expertiseCity/core/steuerrecht/stuttgart.json";
import fr_judgements_steuerrecht_stuttgart from "./expertiseCity/judgements/steuerrecht/stuttgart.json";

export const frExpertiseCityOverlay = {
  arbeitsrecht: {
    Kaiserslautern: {
      ...fr_core_arbeitsrecht_kaiserslautern,
      judgements: fr_judgements_arbeitsrecht_kaiserslautern,
    },
    Koblenz: {
      ...fr_core_arbeitsrecht_koblenz,
      judgements: fr_judgements_arbeitsrecht_koblenz,
    },
    Landau: {
      ...fr_core_arbeitsrecht_landau_pfalz,
      judgements: fr_judgements_arbeitsrecht_landau_pfalz,
    },
    München: {
      ...fr_core_arbeitsrecht_muenchen,
      judgements: fr_judgements_arbeitsrecht_muenchen,
    },
    Pirmasens: {
      ...fr_core_arbeitsrecht_pirmasens,
      judgements: fr_judgements_arbeitsrecht_pirmasens,
    },
    Stuttgart: {
      ...fr_core_arbeitsrecht_stuttgart,
      judgements: fr_judgements_arbeitsrecht_stuttgart,
    },
  },
  erbrecht: {
    Kaiserslautern: {
      ...fr_core_erbrecht_kaiserslautern,
      judgements: fr_judgements_erbrecht_kaiserslautern,
    },
    Koblenz: {
      ...fr_core_erbrecht_koblenz,
      judgements: fr_judgements_erbrecht_koblenz,
    },
    Landau: {
      ...fr_core_erbrecht_landau_pfalz,
      judgements: fr_judgements_erbrecht_landau_pfalz,
    },
    München: {
      ...fr_core_erbrecht_muenchen,
      judgements: fr_judgements_erbrecht_muenchen,
    },
    Pirmasens: {
      ...fr_core_erbrecht_pirmasens,
      judgements: fr_judgements_erbrecht_pirmasens,
    },
    Stuttgart: {
      ...fr_core_erbrecht_stuttgart,
      judgements: fr_judgements_erbrecht_stuttgart,
    },
  },
  gesellschaftsrecht: {
    Heilbronn: {
      ...fr_core_gesellschaftsrecht_heilbronn,
      judgements: fr_judgements_gesellschaftsrecht_heilbronn,
    },
    Kaiserslautern: {
      ...fr_core_gesellschaftsrecht_kaiserslautern,
      judgements: fr_judgements_gesellschaftsrecht_kaiserslautern,
    },
    Koblenz: {
      ...fr_core_gesellschaftsrecht_koblenz,
      judgements: fr_judgements_gesellschaftsrecht_koblenz,
    },
    Köln: {
      ...fr_core_gesellschaftsrecht_koeln,
      judgements: fr_judgements_gesellschaftsrecht_koeln,
    },
    Landau: {
      ...fr_core_gesellschaftsrecht_landau_pfalz,
      judgements: fr_judgements_gesellschaftsrecht_landau_pfalz,
    },
    München: {
      ...fr_core_gesellschaftsrecht_muenchen,
      judgements: fr_judgements_gesellschaftsrecht_muenchen,
    },
    Pirmasens: {
      ...fr_core_gesellschaftsrecht_pirmasens,
      judgements: fr_judgements_gesellschaftsrecht_pirmasens,
    },
    Stuttgart: {
      ...fr_core_gesellschaftsrecht_stuttgart,
      judgements: fr_judgements_gesellschaftsrecht_stuttgart,
    },
  },
  insolvenzrecht: {
    Koblenz: {
      ...fr_core_insolvenzrecht_koblenz,
      judgements: fr_judgements_insolvenzrecht_koblenz,
    },
    Köln: {
      ...fr_core_insolvenzrecht_koeln,
      judgements: fr_judgements_insolvenzrecht_koeln,
    },
    Landau: {
      ...fr_core_insolvenzrecht_landau_pfalz,
      judgements: fr_judgements_insolvenzrecht_landau_pfalz,
    },
  },
  internetmedienrecht: {
    Kaiserslautern: {
      ...fr_core_internetmedienrecht_kaiserslautern,
      judgements: fr_judgements_internetmedienrecht_kaiserslautern,
    },
    Koblenz: {
      ...fr_core_internetmedienrecht_koblenz,
      judgements: fr_judgements_internetmedienrecht_koblenz,
    },
    Landau: {
      ...fr_core_internetmedienrecht_landau_pfalz,
      judgements: fr_judgements_internetmedienrecht_landau_pfalz,
    },
    München: {
      ...fr_core_internetmedienrecht_muenchen,
      judgements: fr_judgements_internetmedienrecht_muenchen,
    },
    Stuttgart: {
      ...fr_core_internetmedienrecht_stuttgart,
      judgements: fr_judgements_internetmedienrecht_stuttgart,
    },
  },
  prozessfuehrung: {
    Kaiserslautern: {
      ...fr_core_prozessfuehrung_kaiserslautern,
      judgements: fr_judgements_prozessfuehrung_kaiserslautern,
    },
    Koblenz: {
      ...fr_core_prozessfuehrung_koblenz,
      judgements: fr_judgements_prozessfuehrung_koblenz,
    },
    Landau: {
      ...fr_core_prozessfuehrung_landau_pfalz,
      judgements: fr_judgements_prozessfuehrung_landau_pfalz,
    },
    München: {
      ...fr_core_prozessfuehrung_muenchen,
      judgements: fr_judgements_prozessfuehrung_muenchen,
    },
    Stuttgart: {
      ...fr_core_prozessfuehrung_stuttgart,
      judgements: fr_judgements_prozessfuehrung_stuttgart,
    },
  },
  startuprecht: {
    Kaiserslautern: {
      ...fr_core_startuprecht_kaiserslautern,
      judgements: fr_judgements_startuprecht_kaiserslautern,
    },
    Koblenz: {
      ...fr_core_startuprecht_koblenz,
      judgements: fr_judgements_startuprecht_koblenz,
    },
    Landau: {
      ...fr_core_startuprecht_landau_pfalz,
      judgements: fr_judgements_startuprecht_landau_pfalz,
    },
    München: {
      ...fr_core_startuprecht_muenchen,
      judgements: fr_judgements_startuprecht_muenchen,
    },
    Stuttgart: {
      ...fr_core_startuprecht_stuttgart,
      judgements: fr_judgements_startuprecht_stuttgart,
    },
  },
  steuerrecht: {
    Kaiserslautern: {
      ...fr_core_steuerrecht_kaiserslautern,
      judgements: fr_judgements_steuerrecht_kaiserslautern,
    },
    Koblenz: {
      ...fr_core_steuerrecht_koblenz,
      judgements: fr_judgements_steuerrecht_koblenz,
    },
    Landau: {
      ...fr_core_steuerrecht_landau_pfalz,
      judgements: fr_judgements_steuerrecht_landau_pfalz,
    },
    München: {
      ...fr_core_steuerrecht_muenchen,
      judgements: fr_judgements_steuerrecht_muenchen,
    },
    Stuttgart: {
      ...fr_core_steuerrecht_stuttgart,
      judgements: fr_judgements_steuerrecht_stuttgart,
    },
  },
} as const;
